import axios from "axios";
import * as L from "leaflet";
import "leaflet.markercluster";
import "leaflet/dist/leaflet.css";
import { useEffect, useRef, useState } from "react";
import { GeoJSON, LayersControl, MapContainer, TileLayer, useMap } from "react-leaflet";
import { useNavigate } from "react-router-dom";

const MapResizeFix = ({ bounds }) => {
  const map = useMap();

  useEffect(() => {
    setTimeout(() => {
      map.invalidateSize();
      if (bounds) {
        map.fitBounds(bounds, { padding: [40, 40] });
      }
    }, 300);
  }, [map, bounds]);

  return null;
};

/* ---------------- ICON ---------------- */
const myIcon = L.icon({
  iconUrl: require("./marker4.jpg"),
  iconSize: [24, 35],
  iconAnchor: [12, 35],
  popupAnchor: [0, -35],
});

const getColor = (ACS) => {
  if (ACS === null || ACS === undefined) return "blue";
  if (ACS < 50) return "red";
  if (ACS <= 60) return "yellow";
  return "green";
};

const HCLMap = ({
  showGeojson,
  projectExist,
  type,
  data,
  season,
  selectedAlias,
}) => {
  const navigate = useNavigate();
  const mapRef = useRef(null);

  const [bounds, setBounds] = useState(null);
  const [adminBoundaries, setAdminBoundaries] = useState(null);
  const [farmerPlots, setFarmerPlots] = useState(null);

  useEffect(() => {
    if (!projectExist) return;

    const loadBoundaries = async () => {
      const features = [];

      if (projectExist?.districts?.length) {
        for (const d of projectExist.districts) {
          const res = await axios.get(
            `https://pixstack.leadsnextech.com/get_districts_geojson?state_code=${projectExist.states[0].value}&district_code=${d.value}`
          );
          features.push(...res.data.features);
        }
      }

      if (!features.length && projectExist?.region_url) {
        const res = await axios.get(projectExist.region_url);
        features.push(...res.data.features);
      }

      const fc = { type: "FeatureCollection", features };
      setAdminBoundaries(fc);

      if (features.length) {
        setBounds(L.geoJSON(fc).getBounds());
      }
    };

    loadBoundaries();
  }, [projectExist]);

  useEffect(() => {
    if (showGeojson?.features) {
      setFarmerPlots(showGeojson);
    }
  }, [showGeojson]);

 

  return (
    <div style={{ height: "100%", width: "100%", position: "relative" }}>
      <MapContainer
        center={[22, 80]}
        zoom={5}
        style={{ height: "100%", width: "100%" }}
        whenCreated={(map) => (mapRef.current = map)}
        whenReady={(e) => {
          setTimeout(() => {
            e.target.invalidateSize();
          }, 300);
        }}
      >
        <MapResizeFix bounds={bounds} />

        <LayersControl collapsed>
          <LayersControl.BaseLayer checked name="Satellite With Labels">
            <TileLayer url="https://mt0.google.com/vt/lyrs=y&x={x}&y={y}&z={z}" />
          </LayersControl.BaseLayer>

          <LayersControl.BaseLayer name="Streets">
            <TileLayer url="https://mt0.google.com/vt/lyrs=m&x={x}&y={y}&z={z}" />
          </LayersControl.BaseLayer>

          {adminBoundaries && (
            <LayersControl.Overlay checked name="Admin Boundaries">
              <GeoJSON
                data={adminBoundaries}
                style={{ color: "yellow", weight: 2, fillOpacity: 0 }}
              />
            </LayersControl.Overlay>
          )}

          {farmerPlots && (
            <LayersControl.Overlay checked name="Plots">
              <GeoJSON
                data={farmerPlots}
                pointToLayer={(_, latlng) =>
                  L.marker(latlng, { icon: myIcon })
                }
                style={(f) => ({
                  color: getColor(f?.properties?.ACS),
                  weight: 3,
                })}
                onEachFeature={(feature, layer) => {
                  layer.bindPopup(`
                    <b>${feature.properties.farmer_name}</b><br/>
                    Mobile: ${feature.properties.phone_number}<br/>
                    ACS: ${feature.properties.ACS ?? 0}
                  `);
                  layer.on("click", () =>
                    navigate(`/farmerDetail/onboarding/${feature.properties.farmer_id}`)
                  );
                }}
              />
            </LayersControl.Overlay>
          )}

       
        </LayersControl>
      </MapContainer>
    </div>
  );
};

export default HCLMap;
